import {useState, useEffect} from 'react'

interface WindowSize {
	width: number | undefined
	height: number | undefined
	isMobile: boolean
	isTablet: boolean
}

// Default values that match desktop rendering to ensure SSR/client consistency
// This prevents hydration mismatches by ensuring initial render matches server
const DEFAULT_SIZE: WindowSize = {
	width: undefined,
	height: undefined,
	isMobile: false,
	isTablet: false,
}

const getSize = (): WindowSize => {
	if (typeof window === 'undefined') {
		return DEFAULT_SIZE
	}
	return {
		width: window.innerWidth,
		height: window.innerHeight,
		isMobile: window.innerWidth < 768,
		isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
	}
}

export const useWindowSize = (): WindowSize => {
	// Always start with default values to match SSR output
	const [windowSize, setWindowSize] = useState<WindowSize>(DEFAULT_SIZE)

	useEffect(() => {
		// Update to actual size after hydration
		const handleResize = (): void => {
			setWindowSize(getSize())
		}

		// Set initial size on mount (after hydration)
		handleResize()

		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return windowSize
}
